const ModalFormActions = ({
  onCancel,
  formId,
  isSubmitting = false,
  cancelDisabled = false,
  submitDisabled = false,
  cancelText = 'Cancel',
  submitText = 'Save',
  submittingText = 'Saving…',
}) => {
  return (
    <>
      <button
        type="button"
        onClick={onCancel}
        className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-surface disabled:cursor-not-allowed disabled:opacity-60"
        disabled={isSubmitting || cancelDisabled}
      >
        {cancelText}
      </button>
      <button
        type="submit"
        form={formId}
        className="inline-flex items-center justify-center rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-text-inverse shadow-md transition hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-surface disabled:cursor-not-allowed disabled:opacity-60"
        disabled={isSubmitting || submitDisabled}
      >
        {isSubmitting ? submittingText : submitText}
      </button>
    </>
  );
};

export default ModalFormActions;

